import {Component} from '@angular/core';
import {environment} from '@env/environment';
import {ES_PLANTILLA_CBET, MARCA, PLANTILLA} from '@app/config/plantilla';
import {TemaService} from '@app/service/tema.service';
import {Store} from '@ngxs/store';
import {combineLatest, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {SesionState} from '@app/state/sesion/sesion.state';

@Component({
    selector: 'app-footer',
    template: `
        <footer class="product-footer" [attr.aria-label]="'Pie de página de ' + marca">
            <div class="product-footer__main">
                <div class="product-footer__brand">
                    <img [src]="logo" [alt]="marca" [class.product-footer__logo--wide]="esCbet" width="50" height="50" />
                    <div class="product-footer__text">
                        <span class="product-footer__name">{{nombre}}</span>
                        <span class="product-footer__description">{{descripcion}}</span>
                    </div>
                </div>
                <nav aria-label="Navegación del pie de página">
                    <a routerLink="/" aria-label="Ir al inicio" title="Ir al inicio">
                        <i class="pi pi-home" aria-hidden="true"></i>
                        <span>Inicio</span>
                    </a>
                </nav>
            </div>
            <div *ngIf="empresa$ | async as empresa" class="product-footer__company"
                 role="group" aria-label="Empresa principal">
                <i class="pi pi-building" aria-hidden="true"></i>
                <div class="product-footer__company-details">
                    <span class="product-footer__company-name">{{empresa.razonSocial}}</span>
                    <span *ngIf="empresa.ruc" class="product-footer__ruc">RUC {{empresa.ruc}}</span>
                </div>
            </div>
        </footer>
    `,
    styleUrls: ['./app.footer.component.scss'],
    standalone: false
})
export class AppFooterComponent {
    readonly marca = PLANTILLA.nombre;
    readonly esCbet = ES_PLANTILLA_CBET;
    readonly nombre = ES_PLANTILLA_CBET ? PLANTILLA.nombre : `${MARCA} Soluciones`;
    readonly descripcion = ES_PLANTILLA_CBET ? PLANTILLA.subtitulo : 'Aplicaciones de alto rendimiento';

    readonly empresa$: Observable<{ruc: string; razonSocial: string} | null>;

    constructor(public readonly tema: TemaService, store: Store) {
        this.empresa$ = combineLatest([
            store.select(SesionState.getCompany), store.select(SesionState.getLogin)
        ]).pipe(map(([company, login]) => {
            if (!login?.user) { return null; }
            const principal = company || login.user.empresa;
            const ruc = String(principal?.ruc ?? '').trim();
            const razonSocial = String(principal?.razonSocial ?? '').trim();
            return ruc || razonSocial ? {ruc, razonSocial} : null;
        }));
    }

    get logo(): string {
        return this.esCbet && !this.tema.oscuro ? PLANTILLA.logoFondoClaro : environment.urlLogo || PLANTILLA.favicon;
    }
}
